import { render, staticRenderFns } from "./ImagePicker.vue?vue&type=template&id=54e6a28a&scoped=true&"
import script from "./ImagePicker.vue?vue&type=script&lang=js&"
export * from "./ImagePicker.vue?vue&type=script&lang=js&"
import style0 from "./ImagePicker.vue?vue&type=style&index=0&id=54e6a28a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6a28a",
  null
  
)

export default component.exports